const langLabels = {
  ruler: {
    name: '规则名称',
    code: '规则编码',
    isUse: '是否启用',
    namePlaceholder: '请输入规则名称',
    codePlaceholder: '请输入规则编码',
    isUsePlaceholder: '全部'
  },
  rulerLog: {
    title: '寻源规则详情',
    mainInfo: '基本信息',
    rulerDetailTitle: '规则明细',
    ruleCode: '规则编码',
    ruleName: '规则名称',
    ruleType: '规则类型',
    isMultiple: '是否支持多选',
    isUse: '是否启用',
    ruleDetail: '规则描述'
  },
  template: {
    templateId: '报告模板ID',
    templateName: '报告模板名称',
    updateTime: '更新时间',
    status: '状态'
  },
  receiveAndFeedback: {
    requireTime: '需求时间',
    requirementCode: '寻源需求编码',
    unit: '采购单位',
    projectName: '项目名称',
    status: '处理状态',
    unitPlaceholder: '请输入',
    projectNamePlaceholder: '请输入',
    requireTimePlaceholder: '请输入',
    statusPlaceholder: '全部',
    searchRequire: '寻源需求',
    searchCondition: '寻源条件',
    sort: '排序指标',
    supplierNum: '供应商数量',
    remark: '备注 ',
    dealStatus: '处理状态',
    sourceExecute: '寻源执行',
    feedbackRecord: '反馈记录',
    sourceFailureRecord: '寻源失败反馈',
    cancel: '取消',
    processProgress: '处理进度',
    feedbackRecord: '反馈记录',
    cancelReason: '取消原因',
    cancelTitle: '寻源取消',
    progressTitle: '查看处理进度',

  },
  dealProgress: {
    oprator: '操作人',
    status: '状态',
    approvalOpinion: '审批意见',
    approvalTime: '审批时间'
  },
  statistics: {
    selectPlaceholder: '全部',
    inputPlaceholder: '请输入',
    time: '时间',
    reportNumber: '报告编号',
    reportTopic: '报告主题',
    oprationPeople: '操作人',
    status: '状态',
    reportTime: '报告日期',
    oprationAccount: '报告账号',
    approvalStatus: '审批状态',
    details: '详情',
    downLoad: '下载',
    downloadRecord: '下载记录'
  },
  retrieval: {
    send: '发送消息',
    generate: '生成寻源报告',
    total: '总体',
    interiorTab: '库内',
    externalTab: '库外',
    supplierName: '供应商名称',
    registeredCapital: '注册资金(万元/人民币)',
    capitalUnit: '资金单位',
    founedTime: '成立年限',
    supplyType: '可供货类型',
    bidNums: '相关投标次数',
    winNums: '相关中标次数',
    gainRate: '中标率（%）',
    source: '来源',
    details: '详情',
    portrayal: '画像'
  },
  feedbackRecord: {
    searchRequirementNumber: '寻源需求编号',
    procurementUnit: '采购单位',
    sourceRequirement: '寻源需求',
    sourceCondition: '寻源条件',
    taxisIndexes: '排序指标',
    supplierNumber: '供应商数量',
    remark: '备注',
    reportNumber: '报告编号',
    reportTopic: '报告主题',
    operator: '操作人',
    report: '报告',
    feedbackContent: '反馈内容',
    sourceNeedInfo: '寻源需求信息',
    sourceResult: '寻源结果'
  },
  sendMessage: {
    note: '短信',
    email: '邮件',
    templateContent: '模板内容：',
    emailTitle: '邮件标题：',
    title: '发送消息',
    sendObject: '发送对象',
    sendType: '发送方式',
    noteContent: '短信内容',
    emailContent: '邮件内容',

  }
}
export default langLabels
